import { render } from "./RequestConfirm.vue?vue&type=template&id=142e2660&ts=true"
import script from "./RequestConfirm.vue?vue&type=script&lang=ts"
export * from "./RequestConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__